import React from 'react'
import { RenderControl } from '@fareye/ui'
import MultiModalDashboard from './MultiModal/MultiModalGraphRender'
import { useMapper, IMapper, TimeZoneProvider } from '@fareye/common'
import version from '../config/npmVersions'
//NOTE: This config is used to render this Route Listing we will move this to server.

export default function MultiModalDashboardMapper(props: IMapper) {
  const [apiData, _] = useMapper({ ...props, version })
  return (
    <TimeZoneProvider>
      <RenderControl variant="m" state={apiData}>
        <MultiModalDashboard {...props} config={apiData.data as any} />
      </RenderControl>
    </TimeZoneProvider>
  )
}
